import { Stack, Typography } from "@mui/material";
import styles from "./ProfileProjects.module.css";
import strings from "../../../strings/Strings";
import {
  ProjectStatusEnum,
  ProjectStatusEnumUtils,
} from "../../../core/enumerations/ProjectStatusEnum";
import ImageAssets from "../../../assets";
import CustomAvatar from "../../../components/common/avatar/MuiAvatar";
import routesNames from "../../../routes/RouteNames";
import { useLocation, useNavigate } from "react-router";
import { createProjectRedux } from "../../../redux/create-project-redux/CreateProjectRedux";
import { useDispatch, useSelector } from "react-redux";
import { getLocalStorageItem } from "../../../utils/LocalStorage";
import { getCookies } from "../../../utils/Cookies";
import { useEffect, useRef } from "react";
import { projectViewCountRequest } from "../../../redux/dashboard-redux/DashboardRedux";

const ProfileProjects = (props: any) => {
  const {
    project,
    index,
    isCollaborated,
    handleSaveProject,
    followOrUnFollowUserRequest,
    profileName,
    profilePic,
    isFollowing,
    profileID,
  } = props;

  const actionDispatch = (dispatch: any) => ({
    saveProject: (data: any) =>
      dispatch(createProjectRedux.actions.saveProjectRequest(data)),
    setCreateProjectState: (data: any) =>
      dispatch(createProjectRedux.actions.setCreateProjectState(data)),
  });

  const { saveProject, setCreateProjectState } = actionDispatch(useDispatch());

  const createProjectState = useSelector(
    (state: any) => state.CreateProjectRedux
  );

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const userDetails: any = getCookies("userDetails");
  const loginUserDetails = JSON.parse(userDetails);
  const projectRef = useRef(null);

  // useEffect(() => {
  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       const entry = entries[0];
  //       if (entry?.isIntersecting && loginUserDetails?.id !== profileID) {
  //         incrementprojectViewCount(project?.id); // Call API
  //       }
  //     },
  //     { threshold: 1.0 } // Ensures the entire post is in view before triggering
  //   );

  //   if (projectRef?.current) {
  //     observer.observe(projectRef?.current);
  //   }

  //   return () => observer.disconnect(); // Cleanup observer on unmount
  // }, [project]);

  // const incrementprojectViewCount = async (id: any) => {
  //   dispatch(projectViewCountRequest(id));
  // };

  const handleProjectClick = () => {
    navigate(routesNames?.projectDetails?.replace(":id", project?.id));
  };

  const getClassName = (status: any) => {
    switch (status) {
      case ProjectStatusEnum.ongoing:
        return {
          color: "#ff7e98",
          icon: ImageAssets.ic_ongoing,
        };

      case ProjectStatusEnum.upcoming:
        return {
          color: "#5c88ff",
          icon: ImageAssets.ic_upcoming,
        };

      case ProjectStatusEnum.completed:
        return {
          color: "#7aeacd",
          icon: ImageAssets.ic_completed,
        };
      default:
        return {
          color: "#7aeacd",
          icon: ImageAssets.ic_completed,
        };
    }
  };

  return (
    <div
      ref={projectRef}
      className={styles["project-card"]}
      onClick={() => handleProjectClick()}
    >
      <div className={styles["project-image"]}>
        <img
          src={project.coverImage || ImageAssets.ic_tree}
          alt={"project-pic"}
        />
      </div>

      <div className={styles["project-details-container"]}>
        <Stack justifyContent={'space-between'} gap={2}>
          <Typography>{project?.name}</Typography>
          {/* <Stack flexDirection={"row"} gap={1}>
            <img
              alt="view"
              className={styles["post-comment-icon"]}
              src={ImageAssets.ic_eye}
              style={{ width: '2rem', height: '2rem', 'filter': 'brightness(0) saturate(100%) invert(55%) sepia(9%) saturate(686%) hue-rotate(186deg) brightness(102%) contrast(91%)' }}
            />
            <Typography
              className={styles["constants"]}
            >
              {project?.viewsCount || 0}
            </Typography>
          </Stack> */}
        </Stack>
        {
          isCollaborated || props?.isFavouriteLists ? (
            <Stack className={styles["profile-details"]} columnGap={0}>
              <img
                src={project.projectOwnerDetails.profilePic}
                alt={"profile-pic"}
                className={styles["profile-image"]}
              />
              <span className={styles["profile-name"]}>
                {project.projectOwnerDetails.userName ||
                  project.projectOwnerDetails.fullName}
              </span>
              {loginUserDetails?.id !== profileID &&
                <span
                  onClick={(e) => {
                    followOrUnFollowUserRequest({
                      userId: loginUserDetails?.id,
                      userIdToFollow: project.projectOwnerDetails?.userId,
                    });
                    e.stopPropagation();
                  }}
                  className={
                    project.projectOwnerDetails.isFollowing
                      ? styles["following"]
                      : styles["follow"]
                  }
                >
                  {project.projectOwnerDetails.isFollowing
                    ? ""
                    : strings.follow}
                </span>
              }
            </Stack>
          ) : (
            <Stack className={styles["profile-details"]} columnGap={0}>
              <img
                src={project.projectOwnerDetails.profilePic || ImageAssets.ic_dummy_profile}
                alt={"profile-pic"}
                className={styles["profile-image"]}
              />
              <span className={styles["profile-name"]}>
                {project.projectOwnerDetails.userName ||
                  project.projectOwnerDetails.fullName}
              </span>
              {loginUserDetails?.id !== profileID && (
                <span
                  onClick={(e) => {
                    followOrUnFollowUserRequest({
                      userId: loginUserDetails?.id,
                      userIdToFollow: profileID,
                    });
                    e.stopPropagation();
                  }}
                  className={
                    isFollowing ? styles["following"] : styles["follow"]
                  }
                >
                  {isFollowing ? "" : strings.follow}
                </span>
              )}
            </Stack>
          )
          // <div className={styles["collaborator-details"]}>
          //   <CustomAvatar
          //     imageAvatars={[
          //       {
          //         imageUrl: ImageAssets.ic_artist_image,
          //         id: 1,
          //       },
          //       {
          //         imageUrl: ImageAssets.ic_artist_image,
          //         id: 2,
          //       },
          //       {
          //         imageUrl: ImageAssets.ic_artist_image,
          //         id: 3,
          //       }, {
          //         imageUrl: ImageAssets.ic_artist_image,
          //         id: 4,
          //       }, {
          //         imageUrl: ImageAssets.ic_artist_image,
          //         id: 5,
          //       }, {
          //         imageUrl: ImageAssets.ic_artist_image,
          //         id: 6,
          //       },
          //     ]}
          //     className={styles["number-of-collaborators"]}
          //     numberOfAvatars={4}
          //     variant="circular"
          //     sx={{
          //       width: { xs: "2.5rem" },
          //       height: { xs: "2.5rem" },
          //     }}
          //     isOtherTextNotThere={true}
          //   />
          // </div>
        }
      </div>

      <span className={styles["project-status"]}>
        <img src={getClassName(project?.projectStatus).icon} alt="" />
        <Typography
          style={{ color: getClassName(project?.projectStatus).color }}
        >
          {ProjectStatusEnumUtils.getEnumValue(project?.projectStatus)}
        </Typography>
      </span>

      {props?.isFavouriteLists ? null : (
        <img
          className={styles["save-button"]}
          alt="save"
          src={
            project?.isProjectSaved
              ? ImageAssets.ic_favourite_active
              : ImageAssets.ic_favourite_inactive
          }
          onClick={(event: any) =>
            handleSaveProject(event, project, isCollaborated)
          }
        />
      )}
    </div>
  );
};

export default ProfileProjects;
